// extracted by mini-css-extract-plugin
export var moveDown = "styles-module--moveDown--f028d";
export var scrollArrow = "styles-module--scrollArrow--0d7a5";
export var scrollArrowButton = "styles-module--scrollArrowButton--143eb";
export var scrollContainer = "styles-module--scrollContainer--5ea61";
export var scrollRightButton = "styles-module--scrollRightButton--3aee7";
export var withText = "styles-module--withText--d9bcc";